/** Shared useFetch key for Amplience page CMS (fetchPage middleware + HierarchyPage). */
export function getAmpliencePageFetchKey(
  deliveryKey: string,
  locale: string,
  vse?: string
) {
  return `content__${deliveryKey}__${locale}__${vse ?? ''}`
}
